<template>
  <div class="panel-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "panel-footer",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Panel/PanelFooter.vue